<template>
  <v-container>
    <h1>hola</h1>
  </v-container>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>
